module.exports = __webpack_public_path__ + "img/connectionsIcon.ebb73555.svg";